(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Hero: Logo-Aufbau, danach Idle; Klick spielt es erneut */
  function initHero(root) {
    const hero = root.querySelector('.lf-hero');
    if (!hero) return;
    const heart = hero.querySelector('.lfdw-heart');
    const stage = hero.querySelector('.lf-hero__logo');

    const build = () => {
      if (!heart) return;
      heart.classList.remove('is-idle', 'is-building');
      void heart.getBoundingClientRect();
      if (reduce) {
        heart.classList.add('is-idle');
        return;
      }
      heart.classList.add('is-building');
      clearTimeout(heart._lfTimer);
      heart._lfTimer = setTimeout(() => {
        heart.classList.remove('is-building');
        heart.classList.add('is-idle');
      }, 2500);
    };

    requestAnimationFrame(() => {
      hero.classList.add('is-ready');
      build();
    });

    if (stage) {
      stage.addEventListener('click', build);
      stage.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          build();
        }
      });
    }

    /* Countdown zum Event */
    const cd = hero.querySelector('[data-lf-countdown]');
    if (cd) {
      const target = new Date(cd.dataset.lfCountdown).getTime();
      const out = {
        d: cd.querySelector('[data-unit="d"]'),
        h: cd.querySelector('[data-unit="h"]'),
        m: cd.querySelector('[data-unit="m"]'),
        s: cd.querySelector('[data-unit="s"]'),
      };
      const pad = (n) => String(n).padStart(2, '0');
      const tick = () => {
        let diff = Math.max(0, target - Date.now());
        const d = Math.floor(diff / 864e5); diff -= d * 864e5;
        const h = Math.floor(diff / 36e5); diff -= h * 36e5;
        const m = Math.floor(diff / 6e4); diff -= m * 6e4;
        const s = Math.floor(diff / 1e3);
        if (out.d) out.d.textContent = d;
        if (out.h) out.h.textContent = pad(h);
        if (out.m) out.m.textContent = pad(m);
        if (out.s) out.s.textContent = pad(s);
      };
      tick();
      clearInterval(cd._lfInt);
      cd._lfInt = setInterval(tick, 1000);
    }
  }

  /* Coming Soon
     Desktop: Hover schaltet das Bild im Panel rechts.
     Mobil: Tippen klappt das Bild direkt unter dem Eintrag auf und wieder zu. */
  const mqMobile = window.matchMedia('(max-width: 900px)');
  const mqHover = window.matchMedia('(hover: hover) and (pointer: fine)');

  function initComingSoon(root) {
    root.querySelectorAll('.lf-cs').forEach((cs) => {
      if (cs._lfInit) return;
      cs._lfInit = true;
      const items = [...cs.querySelectorAll('.lf-cs__item')];
      const slides = [...cs.querySelectorAll('.lf-cs__slide')];
      const counter = cs.querySelector('[data-lf-counter]');
      const total = items.length;
      let current = -1;

      const show = (idx) => {
        current = idx;
        items.forEach((it, i) => {
          const on = i === idx;
          it.classList.toggle('is-active', on);
          if (it.hasAttribute('aria-expanded')) it.setAttribute('aria-expanded', on && mqMobile.matches ? 'true' : 'false');
        });
        const key = idx < 0 ? 'default' : String(idx);
        let hit = false;
        slides.forEach((sl) => {
          const on = sl.dataset.slide === key;
          sl.classList.toggle('is-active', on);
          if (on) hit = true;
        });
        if (!hit) slides.forEach((sl) => sl.classList.toggle('is-active', sl.dataset.slide === 'default'));
        if (counter) {
          const n = idx < 0 ? total : idx + 1;
          counter.textContent = `${String(n).padStart(2, '0')} / ${String(total).padStart(2, '0')}`;
        }
      };

      /* Nach dem Aufklappen den Eintrag im Blick halten, falls ein Eintrag darüber zugeklappt ist */
      const keepInView = (it) => {
        setTimeout(() => {
          const r = it.getBoundingClientRect();
          const header = document.querySelector('.lf-header');
          const top = header ? header.getBoundingClientRect().bottom : 0;
          if (r.top < top + 8 || r.bottom > window.innerHeight) {
            it.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
          }
        }, 380);
      };

      const tap = (i) => {
        const it = items[i];
        if (mqMobile.matches) {
          if (!it.classList.contains('has-image')) return;
          show(current === i ? -1 : i);
          if (current === i) keepInView(it);
        } else {
          show(i);
        }
      };

      items.forEach((it, i) => {
        it.addEventListener('mouseenter', () => {
          if (mqHover.matches && !mqMobile.matches) show(i);
        });
        it.addEventListener('focus', () => {
          if (!mqMobile.matches) show(i);
        });
        it.addEventListener('click', () => tap(i));
        it.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            tap(i);
          }
        });
      });

      const list = cs.querySelector('.lf-cs__list');
      if (list) {
        list.addEventListener('mouseleave', () => {
          if (mqHover.matches && !mqMobile.matches) show(-1);
        });
      }

      /* Startzustand: Desktop zeigt das Sticker-Bild, mobil ist der erste Eintrag mit Bild offen */
      const setInitial = () => {
        if (mqMobile.matches) {
          const first = items.findIndex((it) => it.classList.contains('has-image'));
          show(first);
        } else {
          show(-1);
        }
      };
      setInitial();
      mqMobile.addEventListener('change', setInitial);
    });
  }

  /* Warenkorbzaehler live halten */
  async function refreshCartCount() {
    try {
      const res = await fetch(`${(window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'}cart.js`, { headers: { Accept: 'application/json' } });
      const cart = await res.json();
      document.querySelectorAll('[data-lf-cart-count]').forEach((el) => {
        el.textContent = cart.item_count;
        el.dataset.count = cart.item_count;
      });
    } catch (e) {}
  }
  ['cart:update', 'cart:updated', 'cart:refresh'].forEach((ev) => document.addEventListener(ev, () => setTimeout(refreshCartCount, 150)));

  const init = (root = document) => {
    initHero(root);
    initComingSoon(root);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
